<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div v-if="currentModal">
    <b-modal :title="currentModal.titre" size="xl" hide-footer centered v-model="modalSwitch" id="my-modal">
      <PatrouilleAbeilles @recupObject="emitRecupObject" @audio="reemitAudio" v-if="currentModal.id == 0" />
      <Poste @recupObject="emitRecupObject" @audio="reemitAudio" v-else-if="currentModal.id == 1" />
      <Sartaq
        :hasLetter="hasLetter()"
        @recupObject="emitRecupObject"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 2"
      />
      <ScoutsMarins
        @recupObject="emitRecupObject"
        @closeModal="emitCloseModal"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 3"
      />
      <StandardTelephonique @recupObject="emitRecupObject" @audio="reemitAudio" v-else-if="currentModal.id == 4" />
      <ScoutismeExtension
        @recupObject="emitRecupObject"
        @closeModal="emitCloseModal"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 5"
      />
      <BallonGeant
        @recupObject="emitRecupObject"
        @closeModal="emitCloseModal"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 6"
      />
      <Hopital
        :hasPiqure="hadPiqure()"
        @close="closeModal()"
        @recupObject="emitRecupObject"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 7"
      />
      <Gare
        @recupObject="emitRecupObject"
        @closeModal="emitCloseModal"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 8"
      />
      <ChenillesUrticantes @recupObject="emitRecupObject" @audio="reemitAudio" v-else-if="currentModal.id == 9" />
      <TourParachute
        :hasSeen="seenMeca"
        @recupObject="emitRecupObject"
        @audio="reemitAudio"
        v-else-if="currentModal.id == 10"
      />
      <Mecanicienne
        :hasAll="hasAll()"
        @hasSeen="seenMeca = true"
        @audio="reemitAudio"
        @recupObject="emitRecupObject"
        v-else-if="currentModal.id == 11"
      />
    </b-modal>
  </div>
</template>
<script>
import BallonGeant from "@/components/immersion02/Cluedo/BallonGeant";
import PatrouilleAbeilles from "@/components/immersion02/Cluedo/PatrouilleAbeilles.vue";
import Poste from "@/components/immersion02/Cluedo/Poste.vue";
import Sartaq from "@/components/immersion02/Cluedo/Sartaq.vue";
import ScoutsMarins from "@/components/immersion02/Cluedo/ScoutsMarins.vue";
import StandardTelephonique from "@/components/immersion02/Cluedo/StandardTelephonique.vue";
import ScoutismeExtension from "@/components/immersion02/Cluedo/ScoutismeExtension.vue";
import Hopital from "@/components/immersion02/Cluedo/Hopital.vue";
import Gare from "@/components/immersion02/Cluedo/Gare.vue";
import ChenillesUrticantes from "@/components/immersion02/Cluedo/ChenillesUrticantes.vue";
import TourParachute from "@/components/immersion02/Cluedo/TourParachute.vue";
import Mecanicienne from "@/components/immersion02/Cluedo/Mecanicienne.vue";

export default {
  components: {
    BallonGeant,
    PatrouilleAbeilles,
    Poste,
    Sartaq,
    StandardTelephonique,
    ScoutismeExtension,
    Hopital,
    Gare,
    ChenillesUrticantes,
    TourParachute,
    Mecanicienne,
    ScoutsMarins
  },
  methods: {
    closeModal() {
      this.modalSwitch = false;
    },
    hasLetter() {
      return this.objects.find((obj) => obj.name === "lettre").recover;
    },
    hadPiqure() {
      return this.objects.find((obj) => obj.name === "piqure").recover;
    },
    hasAll() {
      let test = true;
      for (let i = 0; i < this.objects.length; i++) {
        test = test && this.objects[i].recover;
      }
      return test;
    },
    reemitAudio: function (event) {
      this.$emit("audio", event);
    },
    emitRecupObject: function (object) {
      this.$emit("recupObject", object);
    },
    emitCloseModal: function () {
      this.modalSwitch = false;
    }
  },
  props: {
    currentModal: Object,
    open: Boolean,
    objects: Array
  },
  data: function () {
    return {
      modalSwitch: false,
      seenMeca: false
    };
  },
  watch: {
    open: function () {
      this.modalSwitch = true;
    }
  }
};
</script>
